import PortfolioPage from "./PortfolioPage";

export default function MoreReviewsPage() {
  return (
    <PortfolioPage
      pageType="more-reviews"
      title="Real People, Real Reviews"
      subtitle="Hear what our students and brides have to say"
    />
  );
}
